import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_SEARCHED_SCHEMA = Object.freeze({
  SEARCH_QUERY_TERM: '',
  NUM_RESULTS_RETURNED: 0,
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_SEARCHED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SEARCHED_SCHEMA);

export class SearchedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.searched;
  }

  get properties() {
    return this.toJS();
  }
}
